/**
 * Feedback: the bite indicator and short toasts.
 *
 * Attack and the shop both worked and both felt broken, because nothing told the player
 * anything had happened. Kate's kill is a **five-second hold** — without a visible
 * countdown there is no way to know you are two seconds in, or that you are latched onto
 * anything at all.
 */
export class Feedback {
  private readonly bite: HTMLDivElement
  private readonly ring: SVGCircleElement
  private readonly biteLabel: HTMLSpanElement
  private readonly toasts: HTMLDivElement

  constructor(parent: HTMLElement) {
    this.bite = document.createElement('div')
    this.bite.className = 'bite'
    this.bite.hidden = true
    this.bite.innerHTML = `
      <svg viewBox="0 0 64 64" class="bite-svg">
        <circle cx="32" cy="32" r="28" class="bite-track" />
        <circle cx="32" cy="32" r="28" class="bite-fill" />
      </svg>
      <span class="bite-label"></span>`
    this.ring = this.bite.querySelector('.bite-fill')!
    this.biteLabel = this.bite.querySelector('.bite-label')!
    parent.append(this.bite)

    this.toasts = document.createElement('div')
    this.toasts.className = 'toasts'
    parent.append(this.toasts)
  }

  /**
   * Show progress toward the kill. `progress` is 0..1 across Kate's five seconds;
   * `targetHealth` is 0..1 so you can see the animal weakening.
   */
  showBite(progress: number, targetHealth: number, label: string): void {
    this.bite.hidden = false
    const circumference = 2 * Math.PI * 28
    this.ring.style.strokeDasharray = `${circumference}`
    this.ring.style.strokeDashoffset = `${circumference * (1 - progress)}`
    this.biteLabel.textContent = `${label} ${Math.round(targetHealth * 100)}%`
    this.bite.dataset.nearly = progress > 0.75 ? 'yes' : 'no'
  }

  hideBite(): void {
    this.bite.hidden = true
  }

  /** A short message that fades — a purchase, a card, a kill. */
  toast(text: string, kind: 'good' | 'bad' | 'info' = 'info'): void {
    const item = document.createElement('div')
    item.className = 'toast'
    item.dataset.kind = kind
    item.textContent = text
    this.toasts.append(item)
    window.setTimeout(() => {
      item.classList.add('is-going')
      window.setTimeout(() => item.remove(), 400)
    }, 2200)
  }
}
